import {exportActivitiesLocale} from '@gl/lit/common/locale/export_activities.js';
import {locale} from '@gl/lit/common/locale/index.js';

export const ActivityHeaders = [
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.destination
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.destination
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.status
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.status
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.exportTime
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.exportTime
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.added
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.added
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.removed
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.removed
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.rejected
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.rejected
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns.exportId
        .label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns.exportId
        .tooltip,
  },
  {
    label:
      exportActivitiesLocale[locale.current].activitiesTable.columns
        .errorDetails.label,
    tooltip:
      exportActivitiesLocale[locale.current].activitiesTable.columns
        .errorDetails.tooltip,
  },
];
